import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faDolly, faFolderPlus, faAnchor, faFlagCheckered,
  faDesktop, faUsers, faBell, faUser, faStreetView
} from '@fortawesome/free-solid-svg-icons';

function NavItem({ to, icon, label }) {
  const location = useLocation();
  const isActive = location.pathname === to;
  return (
    <li className="nav-item">
      <Link className={`nav-link d-flex align-items-center gap-2 ${isActive ? 'active' : ''}`} to={to}>
        <FontAwesomeIcon icon={icon} className="fa-fw" />
        <span>{label}</span>
      </Link>
    </li>
  );
}

export default function Sidebar() {
  const userData = JSON.parse(localStorage.getItem('current_user') || '{}');
  const role = userData?.role || userData?.rol || 'user';

  const isAdmin = role === 'admin';
  const isViewer = role === 'viewer';
  const isManagerOrAbove = ['admin', 'manager'].includes(role);
  const canManageUsers = ['admin', 'manager', 'user'].includes(role);

  const content = (
    <nav className="sidebar d-flex flex-column py-3 h-100">
      <div className="px-3 pb-2">
        <small className="sidebar-heading d-block text-uppercase">Sevkiyat İşlemleri</small>
        <ul className="nav nav-pills flex-column">
          <NavItem to="/" icon={faDolly} label="Aktif Sevkiyatlar" />
          {!isViewer && <NavItem to="/add" icon={faFolderPlus} label="Yeni Sevkiyat" />}
          {!isViewer && <NavItem to="/inactive-devices" icon={faAnchor} label="İnaktif Cihazlar" />}
          <NavItem to="/history" icon={faFlagCheckered} label="Geçmiş Sevkiyatlar" />
        </ul>
      </div>

      {!isViewer && (
        <>
          <hr className="border-secondary my-2" />
          <div className="px-3 pb-2">
            <small className="sidebar-heading d-block text-uppercase">Sistem Yönetimi</small>
            <ul className="nav nav-pills flex-column">
              {isAdmin && <NavItem to="/devices" icon={faDesktop} label="Cihaz Yönetimi" />}
              {canManageUsers && <NavItem to="/user-management" icon={faUsers} label="Kullanıcı Yönetimi" />}
              <NavItem to="/notifications" icon={faBell} label="Bildirimler" />
            </ul>
          </div>
        </>
      )}

      <hr className="border-secondary my-2" />

      <div className="px-3 pb-2">
        <small className="sidebar-heading d-block text-uppercase">Kullanıcı</small>
        <ul className="nav nav-pills flex-column">
          <NavItem to="/profile" icon={faUser} label="Profilim" />
          {!isViewer && <NavItem to="/viewers" icon={faStreetView} label="İzleyici İşlemleri" />}
        </ul>
      </div>

      {/* Rol göstergesi */}
      <div className="mt-auto px-3 pb-2">
        <div style={{
          background: 'rgba(14,165,233,.08)', border: '1px solid rgba(14,165,233,.15)',
          borderRadius: 8, padding: '6px 10px', fontSize: '.72rem'
        }}>
          <span style={{ color: '#64748b' }}>Rol: </span>
          <span style={{ color: 'var(--teal)', fontWeight: 700, textTransform: 'capitalize' }}>{role}</span>
        </div>
      </div>
    </nav>
  );

  return (
    <>
      <div className="col-md-3 col-lg-2 d-none d-md-flex flex-column p-0" style={{ minHeight: 'calc(100vh - 60px)' }}>
        {content}
      </div>
      <div className="offcanvas offcanvas-start" tabIndex="-1" id="yanMenu" style={{ maxWidth: 260 }}>
        <div className="offcanvas-header" style={{ background: '#0f172a' }}>
          <h6 className="offcanvas-title text-white">TermoTrack</h6>
          <button type="button" className="btn-close btn-close-white" data-bs-dismiss="offcanvas" />
        </div>
        <div className="offcanvas-body p-0" style={{ background: '#0f172a' }}>
          {content}
        </div>
      </div>
    </>
  );
}
